// onDirectDebitExecutePageMatch.js - Orchestrator for direct debit execute page enhancements.

const onDirectDebitExecutePageMatch = () => {
  console.log('Lux Inject: Running onDirectDebitExecutePageMatch')

  if (typeof Lux_initializeDirectDebitRunButton === 'function') {
    Lux_initializeDirectDebitRunButton()
  } else {
    console.error('Lux_initializeDirectDebitRunButton function not found!')
  }
}
